import { Box, Text } from "@chakra-ui/react";
import { FeedItem } from "./types";

interface SectionHeaderConfig {
  label: string;
  color: string;
}

/**
 * Compute the section-header config for a feed item, or null if this item
 * shouldn't open a new section. After the cluster refactor every slot is its
 * own section (clusters compose internally), so this is just a per-type
 * lookup — no run-tracking.
 *
 * Types that omit a header (comic_release, video, bundle, streak) are
 * standalone cards that self-identify visually.
 */
export function getSectionHeader(
  item: FeedItem,
): SectionHeaderConfig | null {
  switch (item.type) {
    case "comic_recommendation":
      return { label: item.rail_title || "You might like", color: "#D87CFF" };
    case "genre_dive":
      return { label: item.rail_title || "More like this", color: "#D87CFF" };
    case "top_comment":
      return { label: "Readers are saying", color: "cyan.300" };
    case "rss_section":
      return { label: "Comics news", color: "orange.300" };
    case "featured_creator":
      return { label: "Discover", color: "cyan.300" };
    case "creator_highlight":
      return { label: "Creator spotlight", color: "#D87CFF" };
    default:
      return null;
  }
}

export function FeedSectionHeader({ label, color }: SectionHeaderConfig) {
  return (
    <Box px={5} pt={2} pb={0.5}>
      <Text
        fontSize="xs"
        fontWeight="extrabold"
        letterSpacing="0.18em"
        textTransform="uppercase"
        color={color}
      >
        {label}
      </Text>
    </Box>
  );
}
